
<ng-container *ngIf="btnType=='blue'">

    <button class="button_purple">
        {{label}}
    </button>
</ng-container>